import { CheckCircle, Clock, Warning } from 'phosphor-react'
import { Modal, OverlayTrigger, Table, Tooltip } from 'react-bootstrap'
import { getValue } from '../../../../utils/getValue'
export function ModalItems({ isOpen, onClose, items }) {
  function renderIcon(status) {
    switch (status) {
      case 'C': {
        return (
          <CheckCircle
            weight="fill"
            color="green"
            size={25}
          />
        )
      }

      case 'D': {
        return (
          <Warning
            weight="fill"
            color="#d91111"
            size={25}
          />
        )
      }

      default: {
        return (
          <Clock
            weight="fill"
            color="orange"
            size={25}
          />
        )
      }
    }
  }

  function renderOverlay(status) {
    switch (status) {
      case 'C': {
        return 'Conferido'
      }

      case 'D': {
        return 'Divergente'
      }

      default: {
        return 'Aguardando'
      }
    }
  }

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      dialogClassName="custom-modalzpl"
    >
      <Modal.Header>
        <Modal.Title>Produtos</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Table>
          <thead>
            <tr>
              <th>SKU</th>
              <th>Descrição</th>
              <th>EAN</th>
              <th>DUN</th>
              <th>Qtd Pedido</th>
              <th>Qtd Conferida</th>
              <th>Qtd Divergente</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            {items.map((item) => (
              <tr>
                <td>{item.codigo}</td>
                <td>{item.descricao}</td>
                <td>{item.ean}</td>
                <td>{item.dun}</td>
                <td>{getValue(item.qtped)}</td>
                <td>{getValue(item.qtconf)}</td>
                <td>{getValue(item.qtdiverg)}</td>
                <td>
                  <OverlayTrigger
                    overlay={
                      <Tooltip>{renderOverlay(item.status.trim())}</Tooltip>
                    }
                  >
                    {renderIcon(item.status.trim())}
                  </OverlayTrigger>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Modal.Body>
    </Modal>
  )
}
